/**
 * TCM Insights for Analysis Screen
 * These provide educational and trust-building context during the AI analysis process.
 */
export const TCM_INSIGHTS = [
    {
        title: "Thiệt vi tạng phủ chi ngoại hầu",
        desc: "Lưỡi là gương soi của ngũ tạng, phản ánh trung thực trạng thái khí huyết."
    },
    {
        title: "Bát Cương Biện Chứng",
        desc: "AI đang đối chiếu dữ liệu với 8 nguyên tắc: Âm - Dương, Biểu - Lý, Hàn - Nhiệt, Hư - Thực."
    },
    {
        title: "9 Đại Thể Chất Vương Kỳ",
        desc: "Hệ thống đang định danh thể chất của bạn dựa trên tiêu chuẩn CCMQ quốc tế."
    },
    {
        title: "Diện chẩn & Ngũ sắc",
        desc: "Khuôn mặt được chia thành các vùng tương ứng với Tâm, Can, Tỳ, Phế, Thận."
    },
    {
        title: "18 Hạng mục Rủi ro",
        desc: "Công nghệ Deep Learning đang đánh giá các chỉ số từ hệ Thần kinh đến Chuyển hóa."
    },
    {
        title: "Sự hòa hợp Thiên - Nhân",
        desc: "YHCT coi trọng sự cân bằng giữa cơ thể và môi trường sống để duy trì sức khỏe."
    },
    {
        title: "Khí huyết lưu thông",
        desc: "Trạng thái của rêu lưỡi và sắc mặt cho thấy mức độ lưu thông của Khí và Huyết."
    }
];

export const TECHNICAL_STEPS = [
    { id: 'prepare', label: 'Số hóa dữ liệu', sub: 'Tiền xử lý & Nén ảnh' },
    { id: 'tongue', label: 'Thiệt tượng học', sub: 'Phân tích Màu & Rêu lưỡi' },
    { id: 'face', label: 'Diện chẩn kỹ thuật', sub: 'Phân tích Ngũ sắc vùng mặt' },
    { id: 'syndrome', label: 'Bát cương chẩn đoán', sub: 'So khớp 8 nguyên tắc cơ bản' },
    { id: 'risk', label: 'Đánh giá 18 rủi ro', sub: 'Phân tích Hệ thống cơ thể' },
    { id: 'report', label: 'Tổng hợp báo cáo', sub: 'Cá nhân hóa khuyến nghị' }
];
